<template>
  <div class="onboarding-modal">
    <div class="header">
      <h1 class="title">
        Bem vindo ao seu clube de vantagens
      </h1>
      <h2 class="subtitle">
        Aqui você encontra os melhores descontos para utilizar nas suas marcas favoritas
      </h2>
    </div>

    <step-two />
    <k-button
      no-icon
      class="onboarding-action-button"
      data-cy="onboarding-action-button"
      @click.native=" $emit('close')"
    >
      Vamos Lá
    </k-button>
  </div>
</template>

<script>
import StepTwo from '@/components/Login/Onboarding/OnboardingStepTwo'
import { KButton } from 'kaledo-components'

export default {
  components: {
    StepTwo,
    KButton
  },
  data () {
    return {
      step: 1
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@style/reference';

.onboarding-modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @include mobile {
    padding: 10px;
    height: 410px;
  }

  > .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    padding-bottom: 32px;

    > .title {
      font-weight: 600;
      font-size: 18px;
      text-align: center;
      color: #4E5364;
      margin-bottom: 10px;
    }

    > .subtitle {
      font-weight: 400;
      font-size: 16px;
      text-align: center;
      color: #4E5364;
    }
  }

  > .onboarding-action-button {
    width: 100%;
    max-width: 300px;
    height: 42px;
    margin-top: 32px;
    background-color: var(--color-primary)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Onboarding/OnboardingModal.vue